import axios from "axios";
import { useState } from "react";
import useToastify from "./useToastify";

const useMultipleImgUpload = () => {
  const [selectedImages, setSelectedImages] = useState([]);
  const [defaultImg, setdefaultImg] = useState("");
  const [ImgLinks, setImgLinks] = useState([]);
    // show toast hook 
  const { notify } = useToastify();;
  const onSelectFile = (event) => {
    const selectedFiles = event.target.files;
    const selectedFilesArray = Array.from(selectedFiles);
    const imagesArray = [];

    selectedFilesArray.map((file) => {
      const dublicateImg = selectedImages.find(
        (prevImg) => prevImg.name == file.name
      );

      if (dublicateImg?.name) {
        return;
      }

      const fileSize = file.size / 1024 / 1024; // in MiB
      if (fileSize > 2) {
        notify("File size has exceeded it max limit of 2MB.", "error");
        return;
      }

      imagesArray.push({
        name: file.name,
        url: URL.createObjectURL(file),
        file: file,
      });
    });

    setSelectedImages((previousImages) => previousImages.concat(imagesArray));

    // FOR BUG IN CHROME
    event.target.value = "";
  };

  function deleteHandler(url) {
    if (url == defaultImg) {
      setdefaultImg("");
    }
    setSelectedImages(selectedImages.filter((e) => e.url !== url));
    URL.revokeObjectURL(url);
  }
  const uploadToserver = async (name,setLoadingss) => {
    const formData = new FormData();
    const filterImages = selectedImages.filter((img) => img.file !== undefined);

    if (filterImages.length == 0) {
      return;
    }
    for (let j = 0; j < filterImages.length; j++) {
      formData.append("image", filterImages[j].file);
    }




    return axios.post("/global/fileupload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((response) => {
        return response;
      })
      .catch((err) => {
        setLoadingss(false)
        if (err.response.status == 400) {
          notify(err.response.data.message, "error");
        }
        else{
          notify(`The file you are trying to upload is too large`, "error");
        }
        return err;
      });
  };

  const handleDefaultImage = (url) => {
    setdefaultImg(url);
  };

  return {
    onSelectFile,
    deleteHandler,
    uploadToserver,
    selectedImages,
    setSelectedImages,
    defaultImg,
    setdefaultImg,
    handleDefaultImage,
    ImgLinks,
    setImgLinks,
  };
};

export default useMultipleImgUpload;
